import React from "react";

const FoodAndDrinks = () => {
    return ( 
        <section id="menu">
            <article>
                <h4>Cocktail & Food Menus</h4>
                <h3>Hand Crafted Cocktails & Damn Good Eats</h3>
                <p>We mix our gin and other spirits with the finest and freshest fruits, juices, syrups and infusions in cocktails inspired by original recipes.</p>
                <button>See Menus</button>
            </article>
            <figure>
            <img src="../images/drinks.png" alt="" />
            </figure>
        </section>
     );
}
 
export default FoodAndDrinks;